import { getYear, isAfter, subWeeks } from 'date-fns'

import type { HoldingWeekDto } from '@hcr/api/consumer'
import { filter, flow, group, sort } from '@hcr/utils'

import { compareDates } from '../../../../../utils'

export const prepareWeekPreviewsData = flow(
  filter<HoldingWeekDto>(week => isAfter(new Date(week.week_end), subWeeks(new Date(), 1))),
  sort<HoldingWeekDto>({
    comparer: compareDates,
    asc: 'week_start',
  }),
  group(week => String(getYear(new Date(week.week_start))))
)
